import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Button, Result, Tabs } from 'antd';

import OpportunityBriefTab from '@totem/components/services/optimize/opportunityDetails/OpportunityBriefTab';
import OpportunityPlanTab from '@totem/components/services/optimize/opportunityDetails/OpportunityPlanTab';
import OpportunitySidebar from '@totem/components/services/optimize/opportunityDetails/OpportunitySidebar';
import Activities from '@totem/components/ticketing/details/activities/activities';
import TicketContext from '@totem/components/ticketing/details/ticketContext';

const OpportunityDetailsLayout = () => {
  const { ticket, loading } = useContext(TicketContext);

  // The ticket fetch stores the API's error body when it fails (e.g. 404/500),
  // so check for the nested ticket rather than just the wrapper.
  if (!loading && !ticket?.ticket) {
    return (
      <Result
        status="warning"
        title="Opportunity could not be loaded"
        subTitle="It may not exist, or you may not have access to it in the current organization."
        extra={
          <Link to="/dashboard/optimize2">
            <Button type="primary">Back to Optimize</Button>
          </Link>
        }
      />
    );
  }

  const tabItems = [
    {
      key: 'brief',
      label: 'Brief',
      children: <OpportunityBriefTab />,
    },
    // {
    //   key: 'evidence',
    //   label: 'Evidence',
    //   children: (
    //     <div style={{ color: '#9CA3AF', fontSize: 13, paddingTop: 8 }}>
    //       Evidence attachments and supporting data will appear here.
    //     </div>
    //   ),
    // },
    {
      key: 'plan',
      label: 'Plan',
      children: <OpportunityPlanTab />,
    },
    {
      key: 'activity',
      label: 'Activity',
      children: ticket ? <Activities /> : null,
    },
  ];

  // The app header (Ant Design Layout.Header) is 64px tall. The layout fills
  // the remaining viewport height so neither pane overflows the screen.
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
      {/* Left sidebar — sticky: stays in view as the right content scrolls */}
      <OpportunitySidebar />

      {/* Right content — scrolls naturally with the page */}
      <div
        style={{
          flex: 1,
          padding: '28px 36px',
          background: '#FFFFFF',
          minHeight: 'calc(100vh - 64px)',
        }}
      >
        <Tabs
          defaultActiveKey="brief"
          items={tabItems}
          style={{ marginBottom: 0 }}
        />
      </div>
    </div>
  );
};

export default OpportunityDetailsLayout;
